<template>
  <div class="list-no-more">
    <span v-if="hasMore && !loading" class="load-more" @click="loadMore">点击加载更多</span>
    <template v-else>
      <a-spin :spinning="loading" size="small" style="margin-right: 10px" />
      <span>{{ loading ? '加载中' : text }}</span>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'EhfNoMore',
  }
</script>

<script setup>
  defineProps({
    text: {
      type: String,
      default() {
        return '暂无更多'
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false
      },
    },
    hasMore: {
      type: Boolean,
      default() {
        return false
      },
    },
  })
  const emit = defineEmits(['load-more'])
  const loadMore = () => {
    emit('load-more')
  }
</script>

<style lang="scss" scoped>
  .list-no-more {
    text-align: center;
    padding: 10px 0;
    color: #999;
    width: 100%;
  }
  .load-more {
    cursor: pointer;
    color: #1890ff;
  }
</style>
